// extracted by mini-css-extract-plugin
var _1 = "O6Lqh";
export { _1 as "base" }
